import { Link } from 'react-router-dom';
import { articleSlugs } from '@/mocks/categories';

export default function ArticleCards() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Kakobuy Spreadsheet Guides & Resources
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Expert-written articles to help you master the Kakobuy Spreadsheet and discover the best finds
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articleSlugs.map((article, i) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className={`group relative rounded-2xl overflow-hidden transition-all duration-500 hover:scale-[1.02] ${
                i === 0 ? 'md:col-span-1' : ''
              }`}
              style={{ aspectRatio: '3/4' }}
            >
              <div className="absolute inset-0 z-0">
                <img
                  src={
                    i === 0
                      ? 'https://readdy.ai/api/search-image?query=Open%20laptop%20on%20rich%20walnut%20wooden%20desk%20displaying%20organized%20spreadsheet%20data%20next%20to%20steaming%20coffee%20cup%20and%20reading%20glasses%20morning%20sunlight%20streaming%20through%20large%20window%20with%20city%20skyline%20view%20productive%20professional%20aesthetic%20warm%20amber%20and%20deep%20brown%20tones&width=600&height=800&seq=article-card-guide-v2&orientation=portrait'
                      : i === 1
                      ? 'https://readdy.ai/api/search-image?query=Notebook%20with%20handwritten%20notes%20and%20colorful%20sticky%20tabs%20next%20to%20tablet%20on%20white%20minimalist%20desk%20desk%20lamp%20casting%20warm%20golden%20circle%20of%20light%20evening%20study%20aesthetic%20academic%20and%20thoughtful%20atmosphere%20navy%20blue%20and%20warm%20yellow%20tones&width=600&height=800&seq=article-card-tips-v2&orientation=portrait'
                      : 'https://readdy.ai/api/search-image?query=Split%20screen%20dual%20monitor%20setup%20showing%20comparison%20data%20charts%20on%20modern%20glass%20desk%20with%20geometric%20office%20plants%20bright%20contemporary%20office%20aesthetic%20clean%20lines%20and%20professional%20atmosphere%20cool%20teal%20and%20white%20tones&width=600&height=800&seq=article-card-compare-v2&orientation=portrait'
                  }
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 z-10 p-5 md:p-6">
                <span className="inline-block text-xs font-medium text-white/80 bg-white/15 backdrop-blur-sm px-2.5 py-1 rounded-full mb-3 whitespace-nowrap">
                  {article.readTime}
                </span>
                <h3 className="font-heading font-semibold text-white text-base md:text-lg leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-white/70 text-xs md:text-sm leading-relaxed line-clamp-2">
                  {article.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}